(function () {
  function resumeScroll(embla) {
    const autoScroll = embla && embla.plugins && embla.plugins().autoScroll;
    if (autoScroll && !autoScroll.isPlaying()) autoScroll.play(0);
  }

  function collectSlides(section) {
    const viewport = section.querySelector('[data-marquee-row="top"]');
    if (!viewport) return [];

    const slides = [];
    const seen = new Set();

    viewport.querySelectorAll('[data-marquee-index]').forEach((card) => {
      const index = Number(card.dataset.marqueeIndex);
      if (!Number.isFinite(index) || seen.has(index)) return;
      seen.add(index);

      const src = card.dataset.videoSrc || '';
      if (!src) return;

      const img = card.querySelector('img');
      slides[index] = {
        src,
        poster: img ? img.currentSrc || img.src : '',
      };
    });

    return slides.filter(Boolean);
  }

  function pauseAllVideos(track) {
    if (!track) return;
    track.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
  }

  function hideAllPlayerControls(track) {
    if (!track) return;
    track.querySelectorAll('video').forEach((video) => {
      video.controls = false;
      video.removeAttribute('controls');
    });
  }

  function playActiveVideo(embla, track) {
    pauseAllVideos(track);
    hideAllPlayerControls(track);
    const slide = track.children[embla.selectedScrollSnap()];
    if (!slide) return;
    const video = slide.querySelector('video');
    if (!video) return;
    video.muted = false;
    video.controls = false;
    const attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function bindPlayerVideoTap(track) {
    track.querySelectorAll('video').forEach((video) => {
      if (video.dataset.controlsBound === 'true') return;
      video.dataset.controlsBound = 'true';

      let down = null;

      video.addEventListener('pointerdown', (event) => {
        down = { x: event.clientX, y: event.clientY };
      });

      video.addEventListener('pointerup', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (!down) return;
        const dx = Math.abs(event.clientX - down.x);
        const dy = Math.abs(event.clientY - down.y);
        down = null;
        if (dx >= 10 || dy >= 10) return;
        event.stopPropagation();
        video.controls = !video.controls;
      });

      video.addEventListener('pointercancel', () => {
        down = null;
      });
    });
  }

  function buildPlayerSlide(slide) {
    const slideEl = document.createElement('div');
    slideEl.className = 'mindpatterns-video-marquee__player-slide';

    const frame = document.createElement('div');
    frame.className = 'mindpatterns-video-marquee__player-frame';

    const video = document.createElement('video');
    video.className = 'mindpatterns-video-marquee__player-video';
    video.setAttribute('playsinline', '');
    video.preload = 'metadata';
    video.controls = false;
    video.src = slide.src;
    if (slide.poster) video.poster = slide.poster;

    frame.appendChild(video);
    slideEl.appendChild(frame);
    return slideEl;
  }

  function openPlayer(section, card, slides) {
    const player = section.querySelector('.mindpatterns-video-marquee__player');
    const viewport = player && player.querySelector('.mindpatterns-video-marquee__player-viewport');
    const track = player && player.querySelector('.mindpatterns-video-marquee__player-track');
    if (!player || !viewport || !track || !slides.length) return;

    const startIndex = Number(card.dataset.marqueeIndex);
    if (!Number.isFinite(startIndex)) return;

    closePlayer(section);

    track.replaceChildren(...slides.map((slide) => buildPlayerSlide(slide)));
    bindPlayerVideoTap(track);

    player.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (typeof EmblaCarousel === 'undefined') return;

    const embla = EmblaCarousel(viewport, { loop: true, align: 'center' });
    player._embla = embla;

    embla.scrollTo(startIndex, true);
    playActiveVideo(embla, track);
    embla.on('select', () => playActiveVideo(embla, track));
  }

  function closePlayer(section) {
    const player = section.querySelector('.mindpatterns-video-marquee__player');
    if (!player || player.hidden) return;

    const track = player.querySelector('.mindpatterns-video-marquee__player-track');
    pauseAllVideos(track);

    if (player._embla) {
      player._embla.destroy();
      player._embla = null;
    }

    if (track) track.replaceChildren();
    player.hidden = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function bindCardOpen(section, embla, card, slides) {
    let down = null;

    card.addEventListener('pointerdown', (event) => {
      down = { x: event.clientX, y: event.clientY };
    });

    card.addEventListener('pointerup', (event) => {
      resumeScroll(embla);
      if (!down) return;
      const dx = Math.abs(event.clientX - down.x);
      const dy = Math.abs(event.clientY - down.y);
      down = null;
      if (dx >= 6 || dy >= 6) return;
      openPlayer(section, card, slides);
    });

    card.addEventListener('pointercancel', () => {
      down = null;
    });
  }

  function initRow(section, slides) {
    const viewport = section.querySelector('[data-marquee-row="top"]');
    if (!viewport || typeof EmblaCarousel === 'undefined') return;

    const track = viewport.querySelector('.mindpatterns-video-marquee__track');
    const overlay = viewport.querySelector('.mindpatterns-video-marquee__overlay');

    const embla = EmblaCarousel(
      viewport,
      {
        loop: true,
        dragFree: true,
        align: 'start',
        containScroll: false,
      },
    );

    embla.on('pointerDown', () => viewport.classList.add('is-dragging'));
    embla.on('pointerUp', () => {
      viewport.classList.remove('is-dragging');
      resumeScroll(embla);
    });

    if (overlay) {
      let down = null;

      overlay.addEventListener('pointerdown', (event) => {
        down = { x: event.clientX, y: event.clientY };
        overlay.classList.add('is-dragging');
      });

      overlay.addEventListener('pointerup', (event) => {
        overlay.classList.remove('is-dragging');
        if (!down) return;
        const dx = Math.abs(event.clientX - down.x);
        const dy = Math.abs(event.clientY - down.y);
        down = null;
        if (dx >= 6 || dy >= 6) return;

        const prev = overlay.style.pointerEvents;
        overlay.style.pointerEvents = 'none';
        const target = document.elementFromPoint(event.clientX, event.clientY);
        overlay.style.pointerEvents = prev || '';

        const card = target && target.closest('[data-marquee-index]');
        resumeScroll(embla);
        if (!card) return;
        openPlayer(section, card, slides);
      });

      overlay.addEventListener('pointercancel', () => {
        down = null;
        overlay.classList.remove('is-dragging');
      });
    }

    track.querySelectorAll('[data-marquee-index]').forEach((card) => {
      bindCardOpen(section, embla, card, slides);
    });
  }

  function initPlayer(section) {
    const player = section.querySelector('.mindpatterns-video-marquee__player');
    if (!player || player.dataset.bound === 'true') return;
    player.dataset.bound = 'true';

    const closeButton = player.querySelector('.mindpatterns-video-marquee__close');
    const prevButton = player.querySelector('.mindpatterns-video-marquee__prev');
    const nextButton = player.querySelector('.mindpatterns-video-marquee__next');
    closeButton.addEventListener('click', () => closePlayer(section));

    player.addEventListener('click', (event) => {
      if (player.hidden) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      if (event.target.closest('.mindpatterns-video-marquee__player-video')) return;
      if (event.target.closest('.mindpatterns-video-marquee__prev')) return;
      if (event.target.closest('.mindpatterns-video-marquee__next')) return;
      if (event.target.closest('.mindpatterns-video-marquee__close')) return;
      closePlayer(section);
    });

    let touchStart = null;

    player.addEventListener(
      'touchstart',
      (event) => {
        if (player.hidden) return;
        const touch = event.touches[0];
        touchStart = { x: touch.clientX, y: touch.clientY };
      },
      { passive: true },
    );

    player.addEventListener(
      'touchmove',
      (event) => {
        if (player.hidden || !touchStart) return;
        const touch = event.touches[0];
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx) * 1.2) {
          touchStart = null;
          closePlayer(section);
        }
      },
      { passive: true },
    );

    player.addEventListener('touchend', () => {
      touchStart = null;
    });

    prevButton.addEventListener('click', (event) => {
      event.stopPropagation();
      if (player._embla) player._embla.scrollPrev();
    });

    nextButton.addEventListener('click', (event) => {
      event.stopPropagation();
      if (player._embla) player._embla.scrollNext();
    });

    window.addEventListener('keydown', (event) => {
      if (player.hidden) return;
      if (event.key === 'Escape') closePlayer(section);
      if (event.key === 'ArrowLeft' && player._embla) player._embla.scrollPrev();
      if (event.key === 'ArrowRight' && player._embla) player._embla.scrollNext();
    });
  }

  function initSection(section) {
    if (!section || section.dataset.marqueeReady === 'true') return;
    const slides = collectSlides(section);
    if (!slides.length) return;
    section.dataset.marqueeReady = 'true';
    initRow(section, slides);
    initPlayer(section);
  }

  function initAll() {
    document.querySelectorAll('.mindpatterns-video-marquee').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.mindpatterns-video-marquee') || event.target.closest('.mindpatterns-video-marquee');
    if (section) {
      section.dataset.marqueeReady = 'false';
      initSection(section);
    }
  });
})();
